import { createAction, props } from '@ngrx/store';
import { IEnvironmentDefinition } from '@commonspirit/ngx-environment';

export enum EnvironmentActionType {
  LOAD = '[Environment] Load'
}

export const loadEnvironment = createAction(EnvironmentActionType.LOAD, props<{ environment: IEnvironmentDefinition }>());
